import { render } from "./delete-profile.vue?vue&type=template&id=3e421b40&scoped=true&ts=true"
import script from "./delete-profile.vue?vue&type=script&lang=ts"
export * from "./delete-profile.vue?vue&type=script&lang=ts"

import "./delete-profile.vue?vue&type=style&index=0&id=3e421b40&lang=sass&scoped=true"

import exportComponent from "/Users/ohirjak/projects/mov-vue/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3e421b40"]])

export default __exports__